module.exports = __webpack_public_path__ + "img/icon_map_188_off_011.2006bd89.png";